<script>

import i18n from "../i18n";
import {logoutUser} from "../api/auth";
import {removeSchoolToken, removeModeratorToken, removeUserData, getUserData, getSchoolToken} from "../utils/auth";


/**
 * Nav-bar Component
 */
export default {
  data() {
    return {
      languages: [
        {
          flag:require("@/assets/images/flags/uz.jpg"),
          language: "uz",
          title:"O'zbek",
        },
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/russia.jpg"),
          language: "ru",
          title: "Русский"
        },
        {
          flag: require("@/assets/images/flags/karakalpak.png"),
          language: "kr",
          title: "Karakalpak"
        }
      ],
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,
    };
  },
  computed:{
    profile(){
      let user = JSON.parse(getUserData())
      return getSchoolToken() ? user.director : user.name
    }
  },
  mounted() {
    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country, flag) {
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      i18n.locale = locale;
      location.reload()
    },
    logoutTheUser() {
      logoutUser().then(() => {
        removeSchoolToken()
        removeModeratorToken()
        removeUserData()
        this.$router.push("/");
      })
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
<!--          <router-link tag="a" to="/" class="logo logo-dark">-->
<!--            <span class="logo-sm">-->
<!--              <img src="@/assets/images/newLogo.png" alt height="200" width="50" />-->
<!--            </span>-->
<!--            <span class="logo-lg">-->
<!--              <img src="@/assets/images/newLogo.png" alt height="200" width="50" />-->
<!--            </span>-->
<!--          </router-link>-->

<!--          <router-link tag="a" to="/" class="logo logo-light">-->
<!--            <span class="logo-sm">-->
<!--              <img src="@/assets/images/mno-logo/client1.png" class="mt-4" alt style="width: 300%"/>-->
<!--            </span>-->
<!--            <span class="logo-lg">-->
<!--              <img src="@/assets/images/mno-logo/client1.png" alt style="width: 50%; margin-top: 50px; margin-right: 40px" />-->
<!--            </span>-->
<!--          </router-link>-->
        </div>
      </div>
      <button
          id="vertical-menu-btn"
          type="button"
          style="margin-right: 1000px"
          class="btn btn-md font-size-16 header-item"
          @click="toggleMenu"
      >
        <i class="fa fa-fw fa-bars"></i>
      </button>
      <div class="d-flex">
        <b-dropdown
          class="d-inline-block d-lg-none ms-2"
          variant="black"
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          right
        >
          <template v-slot:button-content>
            <i class="mdi mdi-magnify"></i>
          </template>

          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('message.Search')"
                  aria-label="Recipient's username"
                />
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </b-dropdown>

        <b-dropdown variant="white" right toggle-class="header-item">
          <template v-slot:button-content>
            <img class :src="flag" alt="Header Language" height="16" />
            {{ text }}
          </template>
          <b-dropdown-item
            class="notify-item"
            v-for="(entry, i) in languages"
            :key="`Lang${i}`"
            :value="entry"
            @click="setLanguage(entry.language, entry.title, entry.flag)"
            :class="{ active: lan === entry.language }"
          >
            <img
              :src="`${entry.flag}`"
              alt="user-image"
              class="me-1"
              height="12"
            />
            <span class="align-middle">{{ entry.title }}</span>
          </b-dropdown-item>
        </b-dropdown>

        <b-dropdown right variant="black" toggle-class="header-item" menu-class="dropdown-menu-end">
          <template v-slot:button-content>
<!--            <img-->
<!--              class="rounded-circle header-profile-user"-->
<!--              src="@/assets/images/users/avatar-1.jpg"-->
<!--              alt="Header Avatar"-->
<!--            />-->
            <b-avatar></b-avatar>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <div class="w-100 d-none d-xl-inline-block ms-1">
            {{user}}
          </div>
          <!-- item-->
          <a
            class="dropdown-item text-danger"
            @click="logoutTheUser"
          >
            <i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
            ></i>
            {{ $t("navbar.dropdown.henry.list.logout") }}
          </a>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>

<style scoped>
a{
  cursor: pointer;
}
</style>
